import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateChatImages } from '../../../actions/chatImages';
import {
  currentOpenChatIDSelector,
  selectContentFullscreenSelectedImageUid,
  chatImagesSelector,
} from '../../../selectors';
import { getFileSrc } from '../../../utils/getFileSrc';

export const useFullscreenGallerySlides = (
  setCurrentSlide: (index: number) => void,
): { src: string; uid: string }[] => {
  const chatImages = useSelector(chatImagesSelector);
  const chatId = useSelector(currentOpenChatIDSelector);
  const selectedImageUid = useSelector(selectContentFullscreenSelectedImageUid);
  const dispatch = useDispatch();

  const chatImagesFiles = chatImages?.files || [];

  const slideIndex = chatImagesFiles.findIndex(file => file.uid === selectedImageUid);

  const slides = chatImagesFiles.map(file => {
    const src = getFileSrc(file.uid, chatId);

    return { src, uid: file.uid };
  });

  React.useEffect(() => {
    setCurrentSlide(slideIndex);

    if (chatImagesFiles.length === slideIndex + 1 && chatImages?.page?.canLoadMore) {
      dispatch(updateChatImages({ chatId: chatId as string, offset: chatImages.files?.length }));
    }
  }, [chatId, chatImages, chatImagesFiles.length, dispatch, slideIndex, setCurrentSlide]);

  return slides;
};
